import PublicIcon from '@mui/icons-material/Public';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import { MenuItemInput } from './menu.utils';
import TuneIcon from '@mui/icons-material/Tune';

export const sharedMenuRaw: MenuItemInput[] = [
  {
    name: 'Localization',
    icon: <PublicIcon />,
    submenu: [
      {
        name: 'Region',
        path: '/localization/region',
        permission: 'localization.region',
      },
      {
        name: 'Country',
        path: '/localization/country',
        permission: 'localization.country',
      },
      {
        name: 'City',
        path: '/localization/city',
        permission: 'localization.city',
      },
      {
        name: 'Unit',
        path: '/localization/unit',
        permission: 'localization.unit',
      },
      {
        name: 'Identified Area',
        path: '/localization/division',
        permission: 'localization.division',
      },
      {
        name: 'Production Phase',
        path: '/nnc/productionphase',
        permission: 'nnc.productionphase',
      },
      {
        name: 'NNC Machine',
        path: '/nnc/machine',
        permission: 'localization.machine',
      },
    ],
  },
  {
    name: 'Accounts',
    icon: <GroupOutlinedIcon />,
    submenu: [
      {
        name: 'User',
        path: '/account/user',
        permission: 'account.user',
      },
      {
        name: 'Group',
        path: '/account/group',
        permission: 'auth.group',
      },
      {
        name: 'Functional Area',
        path: '/nnc/functionalarea',
        permission: 'nnc.functionalarea',
      },
    ],
  },
  {
    name: 'Settings',
    icon: <TuneIcon />,
    path: '/settings/settings/add-update/1',
  },
];
